// extracted by mini-css-extract-plugin
module.exports = {"clear-compare":"ClearCompare_clear-compare__rTwiq","clear-compare__icon":"ClearCompare_clear-compare__icon___9isl"};